import React from 'react'
import anime from 'animejs'
import { useEffect } from 'react'

export default function Sidebar() {

    useEffect(() => {
        anime({
            targets: '#sidebar',
            opacity: [0, 1],
            easing: 'easeInOutSine',
            duration: 1000,
            delay: 3000
        })
    })
    return (
        <div id="sidebar" className="hidden lg:flex">
            <div className="fixed bottom-0 right-16 pl-3 h-screen z-10 flex flex-col justify-end space-y-10">
                <a href="https://github.com/Jintumoni" target="_blank" rel="noreferrer">
                    <img src="/cat.png" alt="link image" className="opacity-30 w-8 h-8 hover:scale-110 hover:opacity-70 transition-all cursor-pointer" />
                </a>
                <a href="https://www.linkedin.com/in/jintu-kalita-9bb207121/" target="_blank" rel="noreferrer">
                    <img src="/linkedin.png" alt="link image" className="opacity-30 w-8 h 10 hover:scale-110 transition-all cursor-pointer hover:opacity-70" />
                </a>
                <a href="https://www.instagram.com/jintu_kalita_133/" target="_blank" rel="noreferrer">
                    <img src="/insta.png" alt="link image" className="opacity-30 w-8 h 10 hover:scale-110 transition-all cursor-pointer hover:opacity-70" />
                </a>
                <a href="https://www.facebook.com/profile.php?id=100013847821829" target="_blank" rel="noreferrer">
                    <img src="/facebook.png" alt="link image" className="opacity-30 w-8 h 10 hover:scale-110 transition-all cursor-pointer hover:opacity-70" />
                </a>
                <div className="transform -translate-x-1/2 border-white-300 h-1/6 border-r z-0 opacity-25"></div>
            </div>
        </div>
    )
}
